import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import type { BoxComponent, BoxProps } from '.';
import { StyledBox } from '.';

export const Box: BoxComponent = forwardRef(
  <C extends ElementType = 'div'>({ ...props }: BoxProps<C>, ref: PolymorphicRef<C>) => {
    return <StyledBox {...props} ref={ref} />;
  },
);
